import { createContext } from "react";

const BeachPayContext = createContext()

export const Provider = BeachPayContext.Provider

export const Consumer = BeachPayContext.Consumer


export default  BeachPayContext;